import { capitalize } from '@superbet-group/web.lib.utilities';

export function deslugify(slug: string): string {
    return slug
        .split('-')
        .filter((it) => !!it.trim())
        .map((word) => capitalize(word))
        .join(' ');
}
